import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

type Props = {
  disabled: boolean;
  onClear?: () => void;
};

/** "Clear all" of the filters; always shown, disabled while there is nothing to clear. */
function ClearAllButton({ disabled, onClear }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  return (
    <ButtonUI
      disabled={disabled}
      icon="fa-solid fa-trash"
      onClick={onClear}
      shape="link"
      size="ultraSmall"
      text={formatMessage({ defaultMessage: 'Clear all', id: 'multiFlightListsMap.filters.clearAll' })}
      type="secondary"
    />
  );
}

export default ClearAllButton;
